var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow",
    transform: "translate(0 -117.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13514",
    "data-name": "Group 13514",
    transform: "translate(0 117.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38050",
    "data-name": "Path 38050",
    d: "M12.841,117.494a.543.543,0,0,0-.766,0L6.5,123.036.925,117.494a.543.543,0,0,0-.766,0,.536.536,0,0,0,0,.761l5.958,5.923a.544.544,0,0,0,.766,0l5.958-5.923A.536.536,0,0,0,12.841,117.494Z",
    transform: "translate(0 -117.336)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowFilter);
export default __webpack_public_path__ + "static/media/down-arrow-filter.3fde6bf0.svg";
export { ForwardRef as ReactComponent };